module.exports = function () {
    if ($('.accordion-module').length === 0) {
        return;
    }

    var isAccordionItemExpanded = function ($accordionItem) {
        if ($accordionItem.hasClass('accordion-module__item--expanded')) {
            return true;
        }
        else {
            return false;
        }
    }

    var syncAccordionItemState = function ($accordionItem, isExpanded) {
        var $accordionItemButton = $accordionItem.find('.accordion-module__item-title-button');
        var $accordionItemPanel = $accordionItem.find('.accordion-module__item-panel');

        $focusablePanelElements = $accordionItemPanel.find('a');
        $panelLottieElements = $accordionItemPanel.find('[data-lottie-src]');

        var windowLotties;
        if (window.lottie !== undefined) {
            windowLotties = window.lottie.getRegisteredAnimations();
        }

        if (isExpanded) {
            var panelInnerHeight = $accordionItemPanel.find('.accordion-module__item-panel-inner').outerHeight(true);
            var panelInnerHeightValue = panelInnerHeight + 'px';
            $accordionItemPanel.css('height', panelInnerHeightValue);
            $accordionItemButton.attr('aria-expanded', 'true');
            $accordionItemPanel.attr('aria-hidden', 'false');
            $focusablePanelElements.attr('tabindex', '');
            
            if ($panelLottieElements.length && windowLotties.length) {
                $panelLottieElements.each(function () {
                    var panelLottieElement = this;
                    for (var i = 0; i < windowLotties.length; i++) {
                        var windowLottie = windowLotties[i];
                        if (windowLottie.wrapper === panelLottieElement) {
                            windowLottie.goToAndPlay(0);
                            break;
                        }
                    }
                });
            }
        }
        else {
            $accordionItemPanel.css('height', 0);
            $accordionItemButton.attr('aria-expanded', 'false');
            $accordionItemPanel.attr('aria-hidden', 'true');
            $focusablePanelElements.attr('tabindex', '-1');
        }
    }

    $('body:not(.body--experience-editor-editing) .accordion-module__item-title-button').on('click', function () {
        var $accordionItem = $(this).closest('.accordion-module__item');
        var isExpanded = isAccordionItemExpanded($accordionItem);
        if (isExpanded) {
            $accordionItem.removeClass('accordion-module__item--expanded');
        }
        else {
            $accordionItem.addClass('accordion-module__item--expanded');
        }

        syncAccordionItemState($accordionItem, !isExpanded);
        setTimeout(refreshAOS, 500);
    });

    var refreshAOS = function () {
        if (window.aos !== undefined) {
            window.aos.refresh();
        }
    }

    var syncAccordionState = function () {
        $('.accordion-module__item').each(function () {
            var $accordionItem = $(this);
            syncAccordionItemState($accordionItem, isAccordionItemExpanded($accordionItem));
        });

        setTimeout(updateBackgroundImageHeight, 500);
    }

    var handleResize = function () {
        syncAccordionState();
    }

    var updateBackgroundImageHeight = function () {
        $('.accordion-module').each(function () {
            var $accordionModule = $(this);
            var moduleHeight = $accordionModule.outerHeight(true);
            var $collapsedAccordionItems = $accordionModule.find('.accordion-module__item').not('.accordion-module__item--expanded');
            $collapsedAccordionItems.find('.accordion-module__item-panel-inner').each(function () {
                moduleHeight += $(this).outerHeight(true);
            });

            var expandedModuleHeightValue = moduleHeight + 'px';
            $accordionModule.find('.module__absolutely-positioned-background').css('height', expandedModuleHeightValue);
        });
    }

    syncAccordionState();

    $(window).resize(function () {
        requestAnimationFrame(handleResize);
    });

    var accordionScrollPending = false;
    window.addEventListener('scroll', () => {
        if (!accordionScrollPending) {
            accordionScrollPending = true;

            requestAnimationFrame(() => {
                $('.accordion-module__item[data-default-state="collapsed-scroll-expand"]').not('[data-handled-scroll-expand]').each(function () {
                    var accordionItemTop = this.getBoundingClientRect().top;
                    if (accordionItemTop <= (window.innerHeight / 2) + 80) {
                        $(this).attr('data-handled-scroll-expand', true).not('.accordion-module__item--expanded').find('.accordion-module__item-title-button').click();
                    }
                });
                accordionScrollPending = false;
            });
        }
    }, { passive: true });

    var accordionInnerItemPanels = document.querySelectorAll('.accordion-module__item-panel-inner');
    accordionInnerItemPanels.forEach(function (accordionInnerItemPanel) {
        var observer = new ResizeObserver(entries => {
            for (var entry of entries) {
                handleResize();
            }
        });

        observer.observe(accordionInnerItemPanel);
    });
};
